module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal whats-new animated fadeIn"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('whats_new_modal.whats_new')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('whats_new_modal.default_message')))])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1631f250","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/whats-new-modal.vue
// module id = 510
// module chunks = 0